import Log from "@/utils/Log";
import { postUrlEncoded } from "../../LegacyAxiosUtil";
import { Step } from "../Step";
import { StepType } from "../StepType";

export abstract class RegisterStep extends Step {
	constructor(step: JQuery, type: StepType) {
		super(step, type);
	}

	public onStepChanging(newStepType: StepType): Promise<boolean> {
		if (newStepType === StepType.BuyMembership) {
			return this.register();
		}

		return super.onStepChanging(newStepType);
	}

	protected async register(): Promise<boolean> {
		this.showProgressIndicator(true, "", true);

		const registerUrl = jQuery(".mia-RegistrationWizard").data("finish-url");
		try {
			const { data } = await postUrlEncoded<{ success: boolean, errorMessage?: string }>(registerUrl, this.wizardData);

			if (data.success) {
				jQuery(".mia-RegistrationWizard").find("a[href=\"#next\"]").removeAttr("href");
			}
			else if (data.errorMessage) {
				this.showErrorMessage(data.errorMessage);
			}

			return data.success;
		}
		catch (error) {
			void Log.error("RegisterStep.register request failed", error);
			return false;
		}
		finally {
			this.hideProgressIndicator();
		}
	}
}
